//Footer for the homepage
export default function Footer(){
    return(
        <div className="home-footer">
        Copyright © Sampark, India. All rights reserved.
    </div>
    )
    
}